module.exports = "input[type='checkbox']:checked + label {\n  text-decoration: none;\n  color: black; }\n\nlabel {\n  color: black; }\n\n.ml-2 {\n  margin-left: 2rem !important; }\n\n.pd-0 {\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/shared/response-of/response-of.component.scss
// module id = ./src/app/forms/shared/response-of/response-of.component.scss
// module chunks = main